import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle, XCircle, Eye, Clock, Filter, Search, FileText, Users, Handshake, DollarSign } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/Tabs';
export function CommitteeApprovals() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const approvals = [{
    id: 1,
    title: 'Pembentukan Chapter Baru - Surabaya',
    type: 'chapter',
    submittedBy: 'Made Suryawan',
    submittedDate: '12 Jan 2025',
    status: 'pending',
    priority: 'high'
  }, {
    id: 2,
    title: 'Permintaan Peningkatan Anggaran Q1 2025',
    type: 'finance',
    submittedBy: 'Dewi Lestari',
    submittedDate: '10 Jan 2025',
    status: 'pending',
    priority: 'high'
  }, {
    id: 3,
    title: 'Kemitraan dengan Tech Corp Indonesia',
    type: 'partnership',
    submittedBy: 'Ahmad Wijaya',
    submittedDate: '8 Jan 2025',
    status: 'pending',
    priority: 'medium'
  }, {
    id: 4,
    title: 'Perubahan Struktur Organisasi Chapter Jakarta',
    type: 'policy',
    submittedBy: 'Budi Santoso',
    submittedDate: '5 Jan 2025',
    status: 'approved',
    approvedDate: '7 Jan 2025',
    priority: 'medium'
  }, {
    id: 5,
    title: 'Pengajuan Event Nasional - Kongres ATIOS 2025',
    type: 'event',
    submittedBy: 'Siti Nurhaliza',
    submittedDate: '3 Jan 2025',
    status: 'approved',
    approvedDate: '4 Jan 2025',
    priority: 'high'
  }];
  const filteredApprovals = approvals.filter(approval => {
    const matchesTab = activeTab === 'all' || approval.status === activeTab;
    const matchesSearch = approval.title.toLowerCase().includes(searchQuery.toLowerCase()) || approval.submittedBy.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesTab && matchesSearch;
  });
  const stats = [{
    label: 'Menunggu Review',
    value: approvals.filter(a => a.status === 'pending').length.toString(),
    icon: Clock,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Disetujui',
    value: approvals.filter(a => a.status === 'approved').length.toString(),
    icon: CheckCircle,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Ditolak',
    value: approvals.filter(a => a.status === 'rejected').length.toString(),
    icon: XCircle,
    color: 'text-error',
    bgColor: 'bg-error-light'
  }];
  const getTypeBadge = (type: string) => {
    switch (type) {
      case 'chapter':
        return <Badge variant="primary" data-id="element-1792">Chapter</Badge>;
      case 'finance':
        return <Badge variant="success" data-id="element-1793">Keuangan</Badge>;
      case 'partnership':
        return <Badge variant="warning" data-id="element-1794">Kemitraan</Badge>;
      case 'policy':
        return <Badge variant="default" data-id="element-1795">Kebijakan</Badge>;
      case 'event':
        return <Badge className="bg-atios-primary text-white" data-id="element-1796">Acara</Badge>;
      default:
        return <Badge data-id="element-1797">Lainnya</Badge>;
    }
  };
  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'chapter':
        return <Users className="w-5 h-5" data-id="element-1798" />;
      case 'finance':
        return <DollarSign className="w-5 h-5" data-id="element-1799" />;
      case 'partnership':
        return <Handshake className="w-5 h-5" data-id="element-1800" />;
      case 'policy':
        return <FileText className="w-5 h-5" data-id="element-1801" />;
      default:
        return <FileText className="w-5 h-5" data-id="element-1802" />;
    }
  };
  const handleApprove = (id: number) => {
    if (confirm('Apakah Anda yakin ingin menyetujui permohonan ini?')) {
      alert(`Permohonan #${id} telah disetujui`);
    }
  };
  const handleReject = (id: number) => {
    const reason = prompt('Alasan penolakan:');
    if (reason) {
      alert(`Permohonan #${id} ditolak. Alasan: ${reason}`);
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-1803">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1804">
        {/* Header */}
        <div className="mb-8" data-id="element-1805">
          <Button variant="ghost" onClick={() => navigate('/committee/dashboard')} className="mb-4" data-id="element-1806">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1807" />
            Kembali ke Dasbor
          </Button>
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-1808">
            Persetujuan Komite
          </h1>
          <p className="text-neutral-600" data-id="element-1809">
            Review dan setujui permohonan dari berbagai unit organisasi
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-1810">
          {stats.map((stat, i) => <Card key={i} data-id="element-1811">
              <CardContent className="p-6" data-id="element-1812">
                <div className="flex items-center gap-4" data-id="element-1813">
                  <div className={`p-3 rounded-lg ${stat.bgColor}`} data-id="element-1814">
                    <stat.icon className={`w-6 h-6 ${stat.color}`} data-id="element-1815" />
                  </div>
                  <div data-id="element-1816">
                    <p className="text-2xl font-semibold text-neutral-900" data-id="element-1817">
                      {stat.value}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-1818">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Search & Filter */}
        <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-1819">
          <div className="flex-1 relative" data-id="element-1820">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-400" data-id="element-1821" />
            <Input placeholder="Cari permohonan..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10" data-id="element-1822" />
          </div>
          <Button variant="secondary" data-id="element-1823">
            <Filter className="w-4 h-4 mr-2" data-id="element-1824" />
            Filter
          </Button>
        </div>

        {/* Tabs */}
        <Tabs defaultValue="all" className="w-full" data-id="element-1825">
          <TabsList className="bg-neutral-100 border border-neutral-200" data-id="element-1826">
            <TabsTrigger value="all" onClick={() => setActiveTab('all')} data-id="element-1827">
              Semua
            </TabsTrigger>
            <TabsTrigger value="pending" onClick={() => setActiveTab('pending')} data-id="element-1828">
              <Clock className="w-4 h-4 mr-2" data-id="element-1829" />
              Menunggu
            </TabsTrigger>
            <TabsTrigger value="approved" onClick={() => setActiveTab('approved')} data-id="element-1830">
              <CheckCircle className="w-4 h-4 mr-2" data-id="element-1831" />
              Disetujui
            </TabsTrigger>
            <TabsTrigger value="rejected" onClick={() => setActiveTab('rejected')} data-id="element-1832">
              <XCircle className="w-4 h-4 mr-2" data-id="element-1833" />
              Ditolak
            </TabsTrigger>
          </TabsList>

          <TabsContent value={activeTab} className="mt-6" data-id="element-1834">
            <Card data-id="element-1835">
              <CardContent className="p-0" data-id="element-1836">
                <Table data-id="element-1837">
                  <TableHeader data-id="element-1838">
                    <TableRow data-id="element-1839">
                      <TableHead className="w-[50px]" data-id="element-1840"></TableHead>
                      <TableHead data-id="element-1841">Judul</TableHead>
                      <TableHead data-id="element-1842">Tipe</TableHead>
                      <TableHead data-id="element-1843">Diajukan Oleh</TableHead>
                      <TableHead data-id="element-1844">Tanggal</TableHead>
                      <TableHead data-id="element-1845">Status</TableHead>
                      <TableHead className="text-right" data-id="element-1846">Aksi</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody data-id="element-1847">
                    {filteredApprovals.map(approval => <TableRow key={approval.id} data-id="element-1848">
                        <TableCell data-id="element-1849">
                          <div className="text-neutral-400" data-id="element-1850">
                            {getTypeIcon(approval.type)}
                          </div>
                        </TableCell>
                        <TableCell data-id="element-1851">
                          <p className="font-medium text-neutral-900" data-id="element-1852">
                            {approval.title}
                          </p>
                        </TableCell>
                        <TableCell data-id="element-1853">{getTypeBadge(approval.type)}</TableCell>
                        <TableCell className="text-neutral-600" data-id="element-1854">
                          {approval.submittedBy}
                        </TableCell>
                        <TableCell className="text-neutral-600" data-id="element-1855">
                          {approval.submittedDate}
                        </TableCell>
                        <TableCell data-id="element-1856">
                          <Badge variant={approval.status === 'pending' ? 'warning' : approval.status === 'approved' ? 'success' : 'error'} data-id="element-1857">
                            {approval.status === 'pending' ? 'MENUNGGU' : approval.status === 'approved' ? 'DISETUJUI' : 'DITOLAK'}
                          </Badge>
                        </TableCell>
                        <TableCell className="text-right" data-id="element-1858">
                          <div className="flex justify-end gap-2" data-id="element-1859">
                            <Button size="sm" variant="ghost" onClick={() => navigate(`/committee/approvals/${approval.id}`)} data-id="element-1860">
                              <Eye className="w-4 h-4" data-id="element-1861" />
                            </Button>
                            {approval.status === 'pending' && <>
                                <Button size="sm" variant="secondary" className="text-error hover:text-error" onClick={() => handleReject(approval.id)} data-id="element-1862">
                                  Tolak
                                </Button>
                                <Button size="sm" onClick={() => handleApprove(approval.id)} data-id="element-1863">
                                  Setujui
                                </Button>
                              </>}
                          </div>
                        </TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </div>;
}